import React from "react";
import { useLanguage } from "../contexts/LanguageContext";
import { social } from "../constants/onedio/social.js";
import Button from "../components/shared/Button.jsx";

export default function Footer() {
  const { language } = useLanguage();

  return (
    <div className="bg-[#F0F2EE] w-full max-w-[1440px] rounded-t-3xl p-12 mx-auto mt-20 flex flex-col gap-6 items-center">
      <div className="flex gap-5">
        {social.map((icon) => (
          <div
            className="w-10 h-10 sm:w-12 sm:h-12 bg-white flex justify-center items-center rounded-full cursor-pointer hover:bg-[#FD9790] hover:scale-110"
            key={icon.id}
          >
            <img src={icon.image} alt={icon.name} loading="lazy" />
          </div>
        ))}
      </div>
      <h2 className="block text-2xl sm:text-4xl mx-auto font-semibold text-center">
        {language === "TR" ? (
          <>
            Birçok farklı ürün ve doğru stratejilerle
            <br />
            ihtiyaçlarınıza çözüm sunabilmemiz için,
          </>
        ) : (
          <>
            For Different Strategies and Enormous
            <br />
            Product Pool,
          </>
        )}
      </h2>
      <p className="block text-md sm:text-xl mx-auto text-center">
        <a href="mailto:sales@onedio.com" className="text-blue-300">
          sales@onedio.com
        </a>{" "}
        {language === "TR" ? (
          <>
            adresinden bizlere ulaşabilirsiniz.
            <br />
            Ya da mail adresinizi aşağıya bırakın, biz size ulaşalım 🤣
          </>
        ) : (
          <>
            You can contact us via sales@onedio.com
            <br />
            Or You can share your e-mail with us, we will contact with you.
          </>
        )}
      </p>
      <div className="flex gap-5">
        <input
          type="text"
          className="rounded-lg bg-white h-11 w-60 sm:w-80 box-shadow p-2 pl-5 outline-none"
        />
        <Button name={language === "TR" ? "Gönder" : "Send"} variant="normal" />
      </div>
    </div>
  );
}
